"use client";

import { CSSProperties, useCallback, useEffect, useRef, useState } from "react";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import styles from "./AnalysisOverview.module.css";
import { TopicBarRow } from "./TopicBarRow";

type Props = {
  row: TopicBarRow;
};

export default function TopicBarItem(props: Props) {
  const { row } = props;
  const [isOverflowing, setIsOverflowing] = useState(false);
  const labelRef = useRef<HTMLSpanElement>(null);

  const checkOverflow = useCallback(() => {
    const element = labelRef.current;
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [checkOverflow]);

  return (
    <li
      className={styles.item}
      style={{ "--topic-color": row.colors.color } as CSSProperties}
      onMouseEnter={checkOverflow}
    >
      <span className={styles.itemMain}>
        <Tooltip
          position={TooltipPosition.RIGHT}
          type={TooltipType.NONE}
          className={styles.topicTooltip}
          disabled={!row.typeLabel}
          trigger={<span className={styles.legendDot} style={{ background: row.colors.color }} />}
          content={row.typeLabel}
        />
        <Tooltip
          position={TooltipPosition.TOP}
          type={TooltipType.NONE}
          className={styles.labelTooltip}
          disabled={!isOverflowing}
          trigger={
            <span ref={labelRef} className={styles.topicLabel}>
              {row.label}
            </span>
          }
          content={row.label}
        />
      </span>

      <span className={styles.itemValue}>{row.hint}</span>
    </li>
  );
}
